// 下载的加载开始和结束
export const LOAD_DOWNLOAD_START = "LOAD_DOWNLOAD_START";
export const LOAD_DOWNLOAD_DONE = "LOAD_DOWNLOAD_DONE";
// 下载弹框的显示和隐藏
export const SHOW_QR_MODAL = "SHOW_QR_MODAL";
export const HIDE_QR_MODAL = "HIDE_QR_MODAL";




// WEBPACK FOOTER //
// ./src/constants/downloadQr.js